import { setContext } from 'apollo-link-context';
export const createAuthLink = (tokenService) => {
    if (!tokenService) {
        throw new Error('Cannot make AuthLink, no instance of TokenService was provided');
    }
    return setContext((_, { headers }) => {
        // get the authentication token if it exists
        const token = tokenService.getToken();
        // return the headers to the context so httpLink can read them
        return {
            headers: Object.assign(Object.assign({}, headers), { authorization: token ? `Bearer ${token}` : '' }),
        };
    });
};
//# sourceMappingURL=createAuthLink.js.map